import React from 'react';

import { type Control, Controller } from 'react-hook-form';

import { Checkbox, FormControlLabel, Stack, TextField } from '@mui/material';

import type { FormValues } from './types';

interface SharpDropFieldsProps {
  control: Control<FormValues>;
  isSubmitting: boolean;
}

export default function SharpDropFields({ control, isSubmitting }: SharpDropFieldsProps) {
  return (
    <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap alignItems="center">
      <Controller
        name="inventoryDropPct"
        control={control}
        rules={{ required: 'Required for sharp drop' }}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            onChange={(e) => field.onChange(Number(e.target.value))}
            type="number"
            label="Drop %"
            required
            disabled={isSubmitting}
            error={!!fieldState.error}
            helperText={fieldState.error?.message ?? 'Inventory drop percentage'}
            sx={{ minWidth: 160 }}
          />
        )}
      />
      <Controller
        name="prevTotalInventoryCount"
        control={control}
        rules={{ required: 'Required for sharp drop' }}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            onChange={(e) => field.onChange(Number(e.target.value))}
            type="number"
            label="Previous Count"
            required
            disabled={isSubmitting}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            sx={{ minWidth: 160 }}
          />
        )}
      />
      <Controller
        name="totalInventoryCount"
        control={control}
        rules={{ required: 'Required for sharp drop' }}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            onChange={(e) => field.onChange(Number(e.target.value))}
            type="number"
            label="Current Count"
            required
            disabled={isSubmitting}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            sx={{ minWidth: 160 }}
          />
        )}
      />
      <Controller
        name="inventoryDropFlag"
        control={control}
        render={({ field }) => (
          <FormControlLabel
            control={<Checkbox {...field} checked={field.value ?? true} disabled={isSubmitting} />}
            label="Drop Flag"
          />
        )}
      />
    </Stack>
  );
}
